import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";

const LINKS = [
  ["Home", "/"],
  ["Portfolio", "/portfolio"],
  ["Services", "/services"],
  ["About", "/about"],
  ["Contact", "/contact"],
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();
  const overHero = pathname === "/" && !scrolled && !open;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <header
      data-testid="nav-header"
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color,padding] duration-500 ${
        overHero ? "bg-transparent border-b border-transparent py-6" : "bg-ivory/90 backdrop-blur-md border-b border-line py-4"
      }`}
    >
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-6 md:px-10">
        <Logo light={overHero} />
        <nav className="hidden items-center gap-9 lg:flex" aria-label="Main">
          {LINKS.map(([label, to]) => (
            <NavLink
              key={to}
              to={to}
              end={to === "/"}
              data-testid={`nav-link-${label.toLowerCase()}`}
              className={({ isActive }) =>
                `nav-link font-sans text-[0.78rem] uppercase tracking-[0.2em] ${overHero ? "text-ivory" : "text-charcoal"} ${isActive ? "is-active" : ""}`
              }
            >
              {label}
            </NavLink>
          ))}
          <Link to="/contact" data-testid="nav-cta-collaborate" className={overHero ? "btn btn-ghost-light" : "btn btn-primary"}>
            Let's Collaborate
          </Link>
        </nav>
        <button
          className={`lg:hidden p-2 -mr-2 ${overHero ? "text-ivory" : "text-wine"}`}
          onClick={() => setOpen((o) => !o)}
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={26} strokeWidth={1.25} /> : <Menu size={26} strokeWidth={1.25} />}
        </button>
      </div>
      {open && (
        <div data-testid="mobile-menu" className="lg:hidden border-t border-line bg-ivory px-6 pb-10 pt-6 h-[calc(100dvh-76px)] overflow-y-auto">
          <nav className="flex flex-col" aria-label="Mobile">
            {LINKS.map(([label, to], i) => (
              <NavLink
                key={to}
                to={to}
                end={to === "/"}
                data-testid={`mobile-nav-link-${label.toLowerCase()}`}
                className="fade-up border-b border-line py-5 font-serif text-4xl text-wine"
                style={{ animationDelay: `${i * 60}ms` }}
              >
                {label}
              </NavLink>
            ))}
          </nav>
          <Link to="/contact" className="btn btn-primary mt-10 w-full justify-center" data-testid="mobile-nav-cta">
            Let's Collaborate
          </Link>
        </div>
      )}
    </header>
  );
};
